/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ArtistRemixContestSubmissionsNotificationAction } from './ArtistRemixContestSubmissionsNotificationAction';
import {
    ArtistRemixContestSubmissionsNotificationActionFromJSON,
    ArtistRemixContestSubmissionsNotificationActionFromJSONTyped,
    ArtistRemixContestSubmissionsNotificationActionToJSON,
} from './ArtistRemixContestSubmissionsNotificationAction';

/**
 * 
 * @export
 * @interface ArtistRemixContestSubmissionsNotification
 */
export interface ArtistRemixContestSubmissionsNotification {
    /**
     * 
     * @type {string}
     * @memberof ArtistRemixContestSubmissionsNotification
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof ArtistRemixContestSubmissionsNotification
     */
    groupId: string;
    /**
     * 
     * @type {boolean}
     * @memberof ArtistRemixContestSubmissionsNotification
     */
    isSeen: boolean;
    /**
     * 
     * @type {number}
     * @memberof ArtistRemixContestSubmissionsNotification
     */
    seenAt?: number;
    /**
     * 
     * @type {Array<ArtistRemixContestSubmissionsNotificationAction>}
     * @memberof ArtistRemixContestSubmissionsNotification
     */
    actions: Array<ArtistRemixContestSubmissionsNotificationAction>;
}

/**
 * Check if a given object implements the ArtistRemixContestSubmissionsNotification interface.
 */
export function instanceOfArtistRemixContestSubmissionsNotification(value: object): value is ArtistRemixContestSubmissionsNotification {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "groupId" in value && value["groupId"] !== undefined;
    isInstance = isInstance && "isSeen" in value && value["isSeen"] !== undefined;
    isInstance = isInstance && "actions" in value && value["actions"] !== undefined;

    return isInstance;
}

export function ArtistRemixContestSubmissionsNotificationFromJSON(json: any): ArtistRemixContestSubmissionsNotification {
    return ArtistRemixContestSubmissionsNotificationFromJSONTyped(json, false);
}

export function ArtistRemixContestSubmissionsNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArtistRemixContestSubmissionsNotification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'groupId': json['group_id'],
        'isSeen': json['is_seen'],
        'seenAt': !exists(json, 'seen_at') ? undefined : json['seen_at'],
        'actions': ((json['actions'] as Array<any>).map(ArtistRemixContestSubmissionsNotificationActionFromJSON)),
    };
}

export function ArtistRemixContestSubmissionsNotificationToJSON(value?: ArtistRemixContestSubmissionsNotification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'group_id': value.groupId,
        'is_seen': value.isSeen,
        'seen_at': value.seenAt,
        'actions': ((value.actions as Array<any>).map(ArtistRemixContestSubmissionsNotificationActionToJSON)),
    };
}

